import { useState } from "react";
import { Abas, Aviso, PainelDaAba } from "../componentes/ui";
import { PainelDeGatilhos } from "../componentes/automacao/PainelDeGatilhos";
import { PainelDeMacros } from "../componentes/automacao/PainelDeMacros";
import { PainelDeTokens } from "../componentes/automacao/PainelDeTokens";
import { PainelDeWebhooks } from "../componentes/automacao/PainelDeWebhooks";
import { podeNaSessao, useSessao } from "../nucleo/sessao";
import { useTitulo } from "../nucleo/titulo";

type Aba = "macros" | "gatilhos" | "webhooks" | "tokens";

const ABAS = [
  { chave: "macros", rotulo: "Macros" },
  { chave: "gatilhos", rotulo: "Gatilhos" },
  { chave: "webhooks", rotulo: "Webhooks" },
  { chave: "tokens", rotulo: "Tokens de API" },
] as const;

/** Automação e integração: o que age sozinho no atendimento e o que conecta o portal a outros sistemas. */
export function Automacao() {
  useTitulo("Automação");
  const sessao = useSessao();
  const [ativa, setAtiva] = useState<Aba>("macros");

  if (!sessao.data) {
    return (
      <p className="lead" role="status">
        Verificando o seu acesso…
      </p>
    );
  }

  const administra = podeNaSessao(sessao.data, "automacao:gerenciar");
  if (!administra && !podeNaSessao(sessao.data, "macro:usar")) {
    return (
      <Aviso tom="marca" data-testid="automacao-sem-permissao">
        A automação do atendimento é mantida pela administração do portal. Para criar gatilhos,
        webhooks ou tokens, peça a quem administra o console.
      </Aviso>
    );
  }

  return (
    <div data-testid="automacao">
      <h1 className="titulo-pagina">Automação</h1>
      <p className="lead mb-4">
        {administra
          ? "Macros para responder com um clique, gatilhos que agem sozinhos nos chamados, webhooks que avisam outros sistemas e tokens para integrações."
          : "Suas macros: respostas prontas que você aplica num chamado com um clique."}
      </p>
      {/* Quem só usa macro (sem gerenciar a automação) vê a aba de macros e mais nada: gatilho,
          webhook e token abrem porta para fora do portal e são da administração. */}
      <Abas
        rotulo="Automação"
        id="automacao"
        itens={administra ? ABAS : ABAS.slice(0, 1)}
        ativa={ativa}
        aoSelecionar={setAtiva}
        className="mb-4"
      />
      <PainelDaAba id="automacao" chave="macros" ativa={ativa} data-testid="painel-macros"><PainelDeMacros /></PainelDaAba>
      {administra ? (
        <>
          <PainelDaAba id="automacao" chave="gatilhos" ativa={ativa} data-testid="painel-gatilhos"><PainelDeGatilhos /></PainelDaAba>
          <PainelDaAba id="automacao" chave="webhooks" ativa={ativa} data-testid="painel-webhooks"><PainelDeWebhooks /></PainelDaAba>
          <PainelDaAba id="automacao" chave="tokens" ativa={ativa} data-testid="painel-tokens"><PainelDeTokens /></PainelDaAba>
        </>
      ) : null}
    </div>
  );
}
